import { post } from './http'
import global from '@/api/global'
// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.crmServer3

// var name = '/crmServer3'

// 模块管理(常)
// 模块管理-列表
export const sModuleList = p => post(name + '/sModule/list', p)
// 模块管理-添加
export const sModuleAdd = p => post(name + '/sModule/add', p)
// 模块管理-删除
export const sModuleDelete = p => post(name + '/sModule/delete', p)
// 模块管理-修改
export const sModuleUpdate = p => post(name + '/sModule/update', p)
// 业务管理(常)
// 业务管理-关联角色获取值（贾）
export const businessRole = p => post(name + '/sRole/businessRole', p)
// 业务管理-关联角色
export const sBusinessRole = p => post(name + '/sBusiness/sBusinessRole', p)
// 业务管理-关联角色回显
export const businessRoleRel = p => post(name + '/sBusiness/businessRoleRel', p)
// 业务管理-添加
export const addParentBusiness = p => post(name + '/sBusiness/addParentBusiness', p)
// 子业务管理管理-添加
export const addBusiness = p => post(name + '/sBusiness/addBusiness', p)
// 业务管理管理-删除
export const sBusinessDelete = p => post(name + '/sBusiness/delete', p)
// 业务管理管理-修改
export const sBusinessUpdate = p => post(name + '/sBusiness/update', p)
// 业务树
export const businessTree = p => post(name + '/sBusiness/businessTree', p)
// 模块列表(常)
export const listModule = p => post(name + '/sModule/listModule', p)
// 菜单按钮添加(贾)
export const sMenuAdd = p => post(name + '/sMenu/add', p)
// 菜单按钮树(贾)
export const sMenuTreeByModuleId = p => post(name + '/sMenu/sMenuTreeByModuleId', p)
// 菜单按钮子集list(贾)
export const childrenList = p => post(name + '/sMenu/childrenList', p)
// 菜单按钮修改(贾)
export const sMenuUpdate = p => post(name + '/sMenu/update', p)
// 菜单按钮删除(贾)
export const sMenuDelete = p => post(name + '/sMenu/delete', p)
// 菜单停用启用(贾)
export const enableOrDisable = p => post(name + '/sMenu/enableOrDisable', p)
// 角色列表(贾)
export const sRoleList = p => post(name + '/sRole/list', p)
// 角色添加(贾)
export const sRoleAdd = p => post(name + '/sRole/add', p)
// 角色修改(贾)
export const sRoleUpdate = p => post(name + '/sRole/update', p)
// 角色删除(贾)
export const sRoleDelete = p => post(name + '/sRole/delete', p)
// 角色停用启用(贾)
export const sRoleEnableOrDisable = p => post(name + '/sRole/enableOrDisable', p)
// 角色修改回显平台角色(贾)
export const sMenuTreeByPlatformRoleId = p => post(name + '/sMenu/sMenuTreeByPlatformRoleId', p)
// 根据角色查权限树(贾)
export const sMenuTreeByRoleId = p => post(name + '/sMenu/sMenuTreeByRoleId', p)
// 根据角色查权限id(贾)
export const sMenuListByRoleId = p => post(name + '/sMenu/sMenuListByRoleId', p)
// 根据业务查权限(贾)
export const sMenuTreeByBusiness = p => post(name + '/sMenu/sMenuTreeByBusiness', p)
// 根据用户查权限(贾)
export const sMenuTreeByUser = p => post(name + '/sMenu/sMenuTreeByUser', p)
// 角色下得用户(常)
export const findUserByRoleId = p => post(name + '/sUser/findUserByRoleId ', p)
// 组织机构(贾)
// 组织机构-树
export const organizationTree = p => post(name + '/sOrganization/organizationTree', p)
// 组织机构-添加
export const organizationAdd = p => post(name + '/sOrganization/add', p)
// 组织机构-修改
export const organizationUpdate = p => post(name + '/sOrganization/update', p)
// 组织机构-删除
export const organizationDelete = p => post(name + '/sOrganization/delete', p)
// 客户列表（平）
export const sCustomerList = p => post(name + '/sCustomer/list', p)
// 客户添加（平）
export const addCustomer = p => post(name + '/sCustomer/addCustomer', p)
// 客户修改（平）
export const updateCustomer = p => post(name + '/sCustomer/updateCustomer', p)
// 客户删除（平）
export const deleteCustomer = p => post(name + '/sCustomer/delete', p)
// 客户详情（平）
export const detailCustomer = p => post(name + '/sCustomer/detail', p)
// 客户导入（平）
export const impCustomerExcel = p => post(name + '/sCustomer/impCustomerExcel', p)
// 机构性质（平）
export const sCrmDictionaryList = p => post(name + '/sCrmDictionary/list', p)
// 企业详情(平）
export const sCompanyDetail = p => post(name + '/sCompany/detail', p)
// 租户列表（平）
export const sTenantList = p => post(name + '/sTenant/list', p)
// 租户新增（平）
export const addTenant = p => post(name + '/sTenant/addTenant', p)
// 租户修改（平）
export const updateTenant = p => post(name + '/sTenant/updateTenant', p)
// 租户详情（平）
export const detailTenant = p => post(name + '/sTenant/detail', p)
// 租户停用启用（平）
export const sTenantEnableDisable = p => post(name + '/sTenant/enableDisable', p)
// 客户关联得租户（平）
export const selectTenantListByCustId = p => post(name + '/sTenant/selectTenantListByCustId', p)
// 查租户下经营业务(常）
export const userTenantBusiness = p => post(name + '/sBusiness/userTenantBusiness', p)
// 查租户下用户列表(常）
export const findTenantUser = p => post(name + '/sUser/findTenantUser', p)
// 用户更改角色(贾）
export const sUseRoleRelUpdate = p => post(name + '/sUseRoleRel/update', p)
// 用户管理(常)
// 用户管理-列表
export const sUserList = p => post(name + '/sUser/list', p)
// 用户管理-详情
export const sUserCheckUser = p => post(name + '/sUser/checkUser', p)
// 用户管理-添加
export const sUserAdd = p => post(name + '/sUser/add', p)
// 用户管理-修改
export const sUserUpdate = p => post(name + '/sUser/update', p)
// 用户管理-删除
export const sUserDelete = p => post(name + '/sUser/delete', p)
// 用户管理-用户授权(贾)
export const roleListByTenant = p => post(name + '/sRole/roleListByTenant', p)
// 用户管理-用户角色
export const roleByUserId = p => post(name + '/sRole/roleByUserId', p)
// 用户管理-短信提示
export const sendMessage = p => post(name + '/sUser/sendMessage', p)
// 用户管理-重置密码
export const updatePassword = p => post(name + '/sUser/updatePassword', p)
// 用户管理-停/启用
export const updateEnableFlag = p => post(name + '/sUser/updateEnableFlag', p)
// 属性使用场景(平)
export const sSceneList = p => post(name + '/sScene/list', p)
// 属性添加(平)
export const sAttributeAddOrUpdate = p => post(name + '/sAttribute/addOrUpdate', p)
// 属性列表(平)
export const sAttributeList = p => post(name + '/sAttribute/list', p)
// 属性删除(平)
export const sAttributeDelete = p => post(name + '/sAttribute/delete', p)
// 属性使用列表(平)
export const sAttributeObjRelList = p => post(name + '/sAttributeObjRel/list', p)
// 属性使用添加(平)
export const sAttributeObjRelAdd = p => post(name + '/sAttributeObjRel/add', p)
// 操作日志(贾)
export const tInfoLogList = p => post(name + '/tInfoLog/list', p)
// 租户管理-客户业务回显
export const sBusinessTenantCustomConfigList = p => post(name + '/sBusinessTenantCustomConfig/list', p)
// 租户管理-客户业务添加
export const sBusinessTenantCustomConfigAdd = p => post(name + '/sBusinessTenantCustomConfig/add', p)
// 租户管理-开通网银
export const sTenantOpenBanking = p => post(name + '/sTenant/openBanking ', p)
// 判断是否能开通网银（平）
export const isOpenBanking = p => post(name + '/sTenant/isOpenBanking', p)
// 获取外部属性（涛）
export const getTAttributeObjRelListCrm3 = p => post(name + '/api/getTAttributeObjRelList', p)

// 跟业务有关
// 车队长审核列表
export const sCompanyCaptainAuditList = p => post(name + '/sCompany/captainAuditList', p)
// 获取车队长基本信息
export const sCompanyCaptainBeanByUserId = p => post(name + '/sCompany/captainBeanByUserId', p)
// 车队长审核列表
export const tAuditHistoryAddAudit = p => post(name + '/tAuditHistory/addAudit', p)
// 车队长审核记录
export const tAuditHistoryList = p => post(name + '/tAuditHistory/list', p)
// 获取企业基本信息
export const sTenantGetTenantDetailByCode = p => post(name + '/sTenant/getTenantDetailByCode', p)
// 属性配置改造
// 属性项维护详情
export const sAttributeDetail = p => post(name + '/sAttribute/detail', p)
// 货主端 基础信息-长协车队 承运商查询（平）
export const selectTenantListFromCustomer = p => post(name + '/sTenant/selectTenantListFromCustomer', p)
// 货主端 基础信息-长协车队 承运商保存（平）
export const sTenantUserBindingRelAdd = p => post(name + '/sTenantUserBindingRel/add', p)
// 货主端 基础信息-长协车队 承运商删除（平）
export const sTenantUserBindingRelDelete = p => post(name + '/sTenantUserBindingRel/delete', p)
// 租户管理-关联租户列表
export const getTenantCustomRelList = p => post(name + '/sTenantCustomOpen/getTenantCustomRelList', p)
// 租户管理-关联租户列表-停用启用
export const disableTenant = p => post(name + '/sTenantCustomOpen/disableTenant', p)
// 用户管理-发送短信
export const getOriginPassUser = p => post(name + '/sUser/getOriginPassUser', p)
// 改 货主端 基础信息-长协车队 承运商查询（平）
export const selectFleetTenantList = p => post(name + '/sTenant/selectFleetTenantList', p)

// 账号绑定列表
export const BindAccountList = p => post(name + '/sUserBindAccount/list', p)
// 密码校验
export const checkUserPwd = p => post(name + '/sUserBindAccount/checkUserPwd', p)
// 新增修改保存
export const saveBindAccount = p => post(name + '/sUserBindAccount/saveBindAccount', p)
// 查询详情
export const findBindAccountDetail = p => post(name + '/sUserBindAccount/findBindAccountDetail', p)
export const sendSmsCode = p => post(name + '/api/register/sendSmsCode', p)
export const deleteZH = p => post(name + '/sUserBindAccount/delete', p)
export const twowayBind = p => post(name + '/sUserBindAccount/twowayBind', p)
export const passiveBindList = p => post(name + '/sUserBindAccount/passiveBindList', p)
// 部门账户（亚）
export const tDepartmentTree = p => post(name + '/sOrganization/tDepartmentTree', p)
// 客户等级列表查询
export const customerGradeList = p => post(name + '/sCustomerGrade/list', p)

// 新增客户等级
export const addCustomerGrade = p => post(name + '/sCustomerGrade/addCustomerGrade', p)
// 删除客户等级
export const deleteCustomerGrade = p => post(name + '/sCustomerGrade/delete', p)
// 编辑用户等级
export const updateCustomerGrade = p => post(name + '/sCustomerGrade/updateCustomerGrade', p)
// 登录账号查询客户等级信息
export const getFindByLoginTenantCode = p => post(name + '/sCustomerGrade/findByLoginTenantCode', p)
// 判断是否可删除客户等级
export const getdeleteFlag = p => post(name + '/sCustomerGrade/deleteFlag', p)
